<script setup>
import Popper from 'vue3-popper'

const handlePopperOpen = (event) => {
    event.currentTarget.querySelector('.popper').style.width = 'max-content'
}
</script>

<template>
     <section class="map">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="title">
                        <h2>Naše pobočky</h2>
                        <div class="buttons">
                            <a href="#" class="c-button c-button--secondary">
                                Pobočky
                                <svg width="17px" height="18px">
                                    <use href="/img/icons/icons.svg#btnArrow"></use>
                                </svg>
                            </a>
                            <a href="#" class="c-button c-button--third">
                                Náš tím
                                <svg width="17px" height="18px">
                                    <use href="/img/icons/icons.svg#btnArrow"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="map-wrapper">
                <img src="/img/map.svg" alt="">

                <div class="map-pins-wrapper">
                   
                    <div class="map-pin" style="left: 45%; top: 45%;" @mouseenter="handlePopperOpen($event)">
                        <Popper hover arrow class="map-popper-theme">
                            <div class="marker">
                                <svg width="82px" height="82px" class="hidden-xs-down">
                                    <use href="/img/icons/icons.svg#marker"></use>
                                </svg>
                                <svg width="28px" height="31px" class="hidden-xs-up">
                                    <use href="/img/icons/icons.svg#markerXs"></use>
                                </svg>
                            </div>
                            <template #content>
                                <div>
                                    SK-949 01 Nitra, Braneckého 17 <br />
                                    Tel.: +421(0)948 186 912 <br />
                                    Tel.: +421(0)948 426 024 <br />
                                    Mail: <a href="mailto:nitra@transfer-personal.sk">nitra@transfer-personal.sk</a> <br />
                                    <a href="www.transfer-personal.sk" target="_blank">www.transfer-personal.sk</a>
                                </div>
                            </template>
                        </Popper>
                    </div>
                
                </div>
            </div>
        </div>
    </section>
</template>

<style>
 /* :root {
    --popper-theme-background-color: #282828;
    --popper-theme-background-color-hover: #333333;
    --popper-theme-text-color: #ffffff;
    --popper-theme-border-width: 0px;
    --popper-theme-border-style: solid;
    --popper-theme-border-radius: 5px;
    --popper-theme-padding: 20px;
    --popper-theme-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  } */

/* .popper {
    min-width: 265px !important;
    color: #fff !important;
    background-color: #282828 !important;
    font-family: 'Roboto', sans-serif !important;
    font-weight: 300 !important;
    font-size: rem-calc(16) !important;
    line-height: rem-calc(27) !important;
    padding: rem-calc(20) !important;
    border-radius: 5px !important;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25) !important;

    a {
        color: inherit;
        text-decoration: underline;
    }
} */
</style>